<template>
  <div class="events-page">
    <Nav />
    <!-- Hero Section -->
    <section class="hero" ref="hero">
      <div class="hero-text animate-left">
        <h1>CONNECTING.SHOWCASING.INNOVATING.</h1>
      </div>
      <div class="hero-bg">
        <img src="@/assets/banner.jpg" alt="QINYUAN GROUP Global Industry Exhibition Business Event Banner">
      </div>
    </section>

    <!-- Intro Text -->
    <section class="intro" ref="intro">
      <div class="container">
        <p class="intro-text-ani">we strongly believe in networking with our partners and peers through
          leading industry events and exhibitions to gain the <br>latest industry insights.</p>
      </div>
    </section>

    <!-- Upcoming Events -->
    <section class="upcoming-events" ref="upcomingEvents">
      <div class="container">
        <h2 class="section-title animate-top" style="font-size:54px;padding:50px 0 10px 0"> UP COMING EVENTS FOR 2026
        </h2>
        <!-- 1 -->
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <!-- 2 -->
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
        <div class="event-card animate-bottom">
          <div class="event-logo animate-scale">
            <img src="@/assets/banner.jpg"
              alt="QINYUAN GROUP Footwear Leather Chemical Industry Global Exhibition Fair">
          </div>
          <div class="event-divider"></div>
          <div class="event-details animate-right">
            <h3>INTERNATIONAL FOOTWEAR AND LEATHER FAIR</h3>
            <ul>
              <li><span>Name</span>: INTERNATIONAL FOOTWEAR AND LEATHER FAIR</li>
              <li><span>Date</span>: 06-09 February, 2026</li>
              <li><span>Venue</span>: BMICH, Colombo, SRI LANKA</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Past Events -->
    <section class="certificates" ref="pastEvents">
      <h2 style="color:#d81f26;text-align:center;font-size:54px;padding:20px 0 44px;" class="animate-top">Past Events
      </h2>
      <div class="container">

        <div class="cert-carousel-wrap" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel">
          <div class="certificates-grid" ref="carouselRef">
            <!-- 原始卡片 -->
            <div class="cert-card animate-scale" style="transition-delay: 0.1s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Polyurethane Technology International Forum 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.2s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">PU Tech 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.3s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">India International Footwear Fair 2023</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.4s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Rymbal Meet at Agra Exhibition</p>
            </div>

            <!-- 复制一份实现无缝循环 -->
            <div class="cert-card animate-scale" style="transition-delay: 0.5s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Polyurethane Technology International Forum 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.6s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">PU Tech 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.7s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">India International Footwear Fair 2023</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.8s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Rymbal Meet at Agra Exhibition</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">

        <div class="cert-carousel-wrap" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel">
          <div class="certificates-grid" ref="carouselRef">
            <!-- 原始卡片 -->
            <div class="cert-card animate-scale" style="transition-delay: 0.1s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Polyurethane Technology International Forum 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.2s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">PU Tech 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.3s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">India International Footwear Fair 2023</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.4s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Rymbal Meet at Agra Exhibition</p>
            </div>

            <!-- 复制一份实现无缝循环 -->
            <div class="cert-card animate-scale" style="transition-delay: 0.5s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Polyurethane Technology International Forum 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.6s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">PU Tech 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.7s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">India International Footwear Fair 2023</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.8s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Rymbal Meet at Agra Exhibition</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">

        <div class="cert-carousel-wrap" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel">
          <div class="certificates-grid" ref="carouselRef">
            <!-- 原始卡片 -->
            <div class="cert-card animate-scale" style="transition-delay: 0.1s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Polyurethane Technology International Forum 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.2s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">PU Tech 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.3s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">India International Footwear Fair 2023</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.4s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Rymbal Meet at Agra Exhibition</p>
            </div>

            <!-- 复制一份实现无缝循环 -->
            <div class="cert-card animate-scale" style="transition-delay: 0.5s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Polyurethane Technology International Forum 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.6s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">PU Tech 2025</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.7s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">India International Footwear Fair 2023</p>
            </div>
            <div class="cert-card animate-scale" style="transition-delay: 0.8s">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP Past International Chemical Raw Material Industry Exhibition Activity"
                class="cert-img">
              <p class="cert-title">Rymbal Meet at Agra Exhibition</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
export default {
  name: "Events",
  data() {
    return {
      carouselAnimation: null,
    };
  },
  mounted() {
    // 谷歌+百度双平台SEO配置
    document.title =
      "EVENTS & EXHIBITION - QINYUAN GROUP | Polyurethane PVC EVA Chemical Raw Material Industry Exhibitions";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content =
      "Founded in 2013, QINYUAN GROUP specializes in polyurethane, PVC, EVA chemical raw materials, production equipment and one-stop technical solutions. We actively participate in global footwear, leather and chemical industry exhibitions, connect with global buyers, expand overseas business covering more than 20 countries.";

    let metaKey = document.querySelector('meta[name="keywords"]');
    if (!metaKey) {
      metaKey = document.createElement("meta");
      metaKey.name = "keywords";
      document.head.appendChild(metaKey);
    }
    metaKey.content =
      "QINYUAN GROUP,industry exhibition,global trade fair,polyurethane exhibition,PVC raw material event,EVA chemical material show,footwear leather industry fair,overseas business development";

    this.carouselAnimation = this.$refs.carouselRef.style.animation;
    this.initScrollAnimation();
  },
  methods: {
    pauseCarousel() {
      this.$refs.carouselRef.style.animationPlayState = "paused";
    },
    resumeCarousel() {
      this.$refs.carouselRef.style.animationPlayState = "running";
    },
    initScrollAnimation() {
      const animElements = document.querySelectorAll(
        ".animate-left, .animate-right, .animate-top, .animate-bottom, .animate-scale, .intro-text-ani"
      );

      const handleScroll = () => {
        animElements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 1.2 && rect.bottom > 0) {
            el.classList.add("animated");
          }
        });
      };

      window.addEventListener("scroll", handleScroll);
      setTimeout(() => {
        handleScroll();
      }, 100);

      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", handleScroll);
      });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.container {
  width: 100%;
  max-width: 1550px;
  margin: 20px auto;
  padding: 0 40px;
  box-sizing: border-box;
}
.events-page {
  overflow-x: hidden;
}

.hero {
  height: 480px;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.hero-text {
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0 0 12rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.hero-text h1 {
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1.2;
  margin: -36px 0 0 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    #d81f26 0%,
    #d81f26 40%,
    rgba(216, 31, 38, 0) 100%
  );
  z-index: 1;
}

/* Intro */
.intro {
  background: #f8f8f8;
  padding: 2rem 0;
  text-align: center;
  position: relative;
  z-index: 1;
}

.intro .container {
  max-width: 1500px;
  margin: 0 auto;
}
.intro p {
  color: #000 !important;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.6;
  opacity: 1;
  position: relative;
  z-index: 2;
}
/*up*/
.upcoming-events {
  background: #fff;
  padding: 0 0 4rem;
  margin: 0 auto;
}
.section-title {
  width: 100%;
  padding: 20px;
  background: #fff;
  color: #d81f26;
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.event-card {
  width: 100%;
  background: #fff;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.event-logo {
  flex-shrink: 0;
  width: 400px !important;
  text-align: center;
}

.event-logo img {
  width: 400px !important;
  height: 270px !important;
  object-fit: cover;
  margin-left: -30px;
}

.event-divider {
  width: 2px;
  height: 150px;
  background: #d81f26;
  flex-shrink: 0;
}

.event-details h3 {
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

.event-details ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.event-details ul li {
  margin-bottom: 0.8rem;
  color: #333;
  display: flex;
  gap: 1rem;
  font-size: 1rem;
}

.event-details ul li span {
  font-weight: 700;
  min-width: 70px;
}

@media (min-width: 1200px) {
  .event-card {
    max-width: 1100px;
    padding: 2.5rem;
    gap: 2.5rem;
  }
  .event-logo img {
    width: 300px;
    height: 300px;
  }
  .event-divider {
    height: 280px;
  }
  .event-details h3 {
    font-size: 1.8rem;
    margin-bottom: 1.8rem;
  }
  .event-details ul li {
    font-size: 1.15rem;
    margin-bottom: 1rem;
    gap: 1.2rem;
  }
  .event-details ul li span {
    min-width: 80px;
  }
}
/*轮播图*/
.certificates {
  padding: 1rem 70px 60px;
  margin: -30px 0 60px 0;
  background-color: #f8f8f8;
  overflow: hidden;
  position: relative;
}

.cert-carousel-wrap {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 0 1rem;
}

.certificates-grid {
  display: flex;
  gap: 2.5rem;
  animation: certScroll 30s linear infinite;
  flex-shrink: 0;
  width: fit-content;
}

.cert-card {
  width: 380px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.cert-img {
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.cert-img:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.cert-title {
  text-align: center;
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
  line-height: 1.4;
  margin: 0;
}

.cert-carousel-wrap:hover .certificates-grid {
  animation-play-state: paused !important;
}

@keyframes certScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-50% - 1.25rem));
  }
}

@media (max-width: 992px) {
  .cert-card {
    width: 280px;
  }
}

/*核心动画*/
.animate-left,
.animate-right,
.animate-top,
.animate-bottom,
.animate-scale {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform, opacity;
}
.animate-left {
  transform: translateX(-80px);
}
.animate-right {
  transform: translateX(80px);
}
.animate-top {
  transform: translateY(-60px);
}
.animate-bottom {
  transform: translateY(60px);
}
.animate-scale {
  transform: scale(0.85);
}
.intro-text-ani {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform, opacity;
}

.animate-left.animated,
.animate-right.animated,
.animate-top.animated,
.animate-bottom.animated,
.animate-scale.animated,
.intro-text-ani.animated {
  opacity: 1;
  transform: translate(0) scale(1);
}

/* 新增全尺寸移动端适配 不改动原有样式逻辑 */
@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
  .hero {
    height: 320px;
  }
  .hero-text {
    padding: 0 20px;
  }
  .hero-text h1 {
    font-size: 1.8rem;
  }
  .event-card {
    flex-direction: column;
    padding: 1.5rem;
  }
  .event-logo {
    width: 100% !important;
  }
  .event-logo img {
    width: 100% !important;
    margin-left: 0;
  }
  .event-divider {
    display: none;
  }
  .certificates {
    padding: 1rem 20px 40px;
  }
}
</style>